module.exports = __webpack_public_path__ + "img/iata.63bef0c7.png";